const React = window.React;


/**
 * Get current selected text. Draft.js doesn't have an built-in way to get the selected text from a selected area,
 * the code here is from: https://github.com/facebook/draft-js/issues/442#issuecomment-223816158
 * @param  {Draft.ContentState}
 * @param  {Draft.SelectionState}
 * @param  {String}
 * @return {String}
 */
function _getTextSelection(contentState, selection, blockDelimiter) {
    blockDelimiter = blockDelimiter || '\n';
    var startKey = selection.getStartKey();
    var endKey = selection.getEndKey();
    var blocks = contentState.getBlockMap();

    var lastWasEnd = false;
    var selectedBlock = blocks
        .skipUntil(function (block) {
            return block.getKey() === startKey;
        })
        .takeUntil(function (block) {
            var result = lastWasEnd;

            if (block.getKey() === endKey) {
                lastWasEnd = true;
            }

            return result;
        });

    return selectedBlock
        .map(function (block) {
            var key = block.getKey();
            var text = block.getText();

            var start = 0;
            var end = text.length;

            if (key === startKey) {
                start = selection.getStartOffset();
            }
            if (key === endKey) {
                end = selection.getEndOffset();
            }

            text = text.slice(start, end);
            return text;
        })
        .join(blockDelimiter);
}

// Not a real React component – just creates the entities as soon as it is rendered.
class TaggerSource extends React.Component {
    componentDidMount() {
        const Modifier = window.DraftJS.Modifier;
        const EditorState = window.DraftJS.EditorState;

        const {
            editorState,
            entityType,
            onComplete
        } = this.props;

        const content = editorState.getCurrentContent();
        const selection = editorState.getSelection();

        const selectedText = _getTextSelection(content, selection);

        this.addTag(selectedText);

        // Uses the Draft.js API to create a new entity with the right data.
        const contentWithEntity = content.createEntity(entityType.type, 'IMMUTABLE', {
            tag: selectedText,
        });

        const entityKey = contentWithEntity.getLastCreatedEntityKey();

        const newContent = Modifier.replaceText(content, selection, selectedText, null, entityKey);
        const nextState = EditorState.push(editorState, newContent, 'insert-characters');

        onComplete(nextState);
    }

    /**
     * Find the first taggit input field and add the given tag to it.
     * @param tagName - The name of the tag to create.
     */
    addTag(tagName) {
        const tagInput = window.$('.admin_tag_widget').find('input').not('.ui-widget-content').first();
        window.$(tagInput).tagit('createTag', tagName);
    }

    render() {
        return null;
    }
}


/**
 * Used to style the tagged text within the editor.
 *
 * Currently doesn't add any styling to the selected text, but just returns it as is.
 */
const Tag = ({children}) => {
    return children;
}

try {
    window.draftail.registerPlugin({
        type: '_TAGGER',
        source: TaggerSource,
        decorator: Tag,
    });
} catch (e) {
    console.error('Unable to register draftail plugin.', e);
}
